export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-projection-screen-31b5e21596ca36968f1dfb82beb5dfb1.svg";